import { b as n, c as i, d as e } from "../../../index-34b1f277.js";
const { defineMultiStyleConfig: r, definePartsStyle: a } = i([
  "button",
  "buttonItem",
  "content",
  "item",
  "divider"
]), t = n("dropdown-bg"), o = n("dropdown-shadow"), l = e({
  [t.variable]: "colors.white",
  [o.variable]: "shadows.100",
  position: "relative",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "2",
  color: "inherit",
  minWidth: "max-content !important",
  maxWidth: "100% !important",
  padding: "2",
  zIndex: "dropdown",
  borderRadius: "lg",
  background: t.reference,
  boxShadow: o.reference + " !important",
  // TODO: remove !important when shadows are fixed
  outline: "none"
}), s = e({
  [t.variable]: "colors.white",
  position: "sticky",
  bottom: 0,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  minWidth: "40",
  paddingBottom: 2,
  transform: "translateY(8px)",
  background: t.reference
}), d = e({
  flex: "1 0",
  display: "inline-flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: 2,
  height: 8,
  padding: 2,
  maxWidth: "320px",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  borderRadius: "4px",
  outlineColor: "white",
  fontSize: "md",
  textAlign: "left",
  _focus: {
    [t.variable]: "colors.gray.100"
  },
  _focusVisible: {
    [t.variable]: "colors.white",
    outlineColor: "secondary.50"
  },
  _active: {
    [t.variable]: "colors.gray.200",
    // Not sure why the background is not applied using [$bg.variable],
    // but it works when using the backgroundColor directly
    backgroundColor: "primary.100"
  },
  _expanded: {
    [t.variable]: "colors.gray.100"
  },
  _hover: {
    [t.variable]: "colors.primary.50",
    outline: "none"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: t.reference,
  "p, span": {
    overflow: "hidden"
  },
  svg: {
    marginTop: "3px"
  }
}), c = e({
  border: "none",
  backgroundColor: "primary.100",
  flex: "0 0 1px"
}), p = e({
  transitionProperty: "common",
  transitionDuration: "normal",
  paddingX: "4"
}), b = e({
  justifyContent: "flex-start",
  textAlign: "left"
}), f = a({
  actions: s,
  button: p,
  buttonItem: b,
  content: l,
  item: d,
  divider: c
}), u = r({
  baseStyle: f,
  variants: {
    truncated: {
      item: {
        "p, span": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }
    }
  }
});
export {
  u as Dropdown
};
//# sourceMappingURL=Dropdown.es.js.map
